class Model{
    constructor(id, name, image, products=[]){
        this.id = id;
        this.name = name;
        this.image = image;
        this.products = products;
    }
}

export default Model